export default "__VITE_ASSET__Dg9Isb_S__"